import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Logo from '../../../assets/app-only/images/logo.svg';
import { TenantContext } from '../../../contexts/TenantContext';

const Brand: React.FC = () => {
  const { t } = useTranslation();
  const { tenantInfo } = useContext(TenantContext);

  const logoSrc = tenantInfo?.logo_path || Logo;
  const brandName = tenantInfo?.name;

  return (
    <a href="#" className="app-brand-link gap-2" onClick={(e) => e.preventDefault()}>
      <span className="app-brand-logo demo">
        <img
          src={logoSrc}
          style={{ height: '32px' }}
          alt={t('layout.pageTexts.private.sidebar.logoAltText')}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = Logo;
          }}
        />
      </span>
      <span className="app-brand-text demo text-heading fw-semibold">{brandName}</span>
    </a>
  );
};

export default Brand;
